import { render } from "./RepeatFreqWeeklyOptions.vue?vue&type=template&id=8e22c55c"
import script from "./RepeatFreqWeeklyOptions.vue?vue&type=script&lang=js"
export * from "./RepeatFreqWeeklyOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__